// Market Insights Action Types
export const FETCHING_MARKET_INSIGHTS = "FETCHING_MARKET_INSIGHTS";
export const FETCH_MARKET_INSIGHTS_SUCCEEDED =
  "FETCH_MARKET_INSIGHTS_SUCCEEDED";
export const FETCH_MARKET_INSIGHTS_FAILED = "FETCH_MARKET_INSIGHTS_FAILED";
export const FETCH_MARKET_INSIGHT_BY_SLUG = "FETCH_MARKET_INSIGHT_BY_SLUG";
export const FETCH_MARKET_INSIGHT_BY_SLUG_ERROR =
  "FETCH_MARKET_INSIGHT_BY_SLUG_ERROR";
